import { render, staticRenderFns } from "./AlertStats.vue?vue&type=template&id=74eeb6b8&scoped=true"
import script from "./AlertStats.vue?vue&type=script&lang=js"
export * from "./AlertStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eeb6b8",
  null
  
)

export default component.exports